module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timespanpicker"
  }, [_c('div', {
    staticClass: "current bold",
    class: {
      active: _vm.display
    },
    on: {
      "click": function($event) {
        return _vm.toggle()
      }
    }
  }, [_vm._v("\n  \t\t" + _vm._s(_vm.current.label) + "\n  \t")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.display),
      expression: "display"
    }],
    staticClass: "values"
  }, _vm._l((_vm.spans), function(span, id) {
    return _c('div', {
      key: id,
      staticClass: "value bold",
      on: {
        "click": function($event) {
          return _vm.setSelected(id)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(span.label) + "\n\t\t\t")])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-260155de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timespanpicker.vue
// module id = 1087
// module chunks = 0